// extracted by mini-css-extract-plugin
export default {"item__metrics":"ItemMetrics_item__metrics__4XF3x","metrics__item":"ItemMetrics_metrics__item__LIRTf"};